export type UrlErrorCode = 'empty' | 'invalid' | 'unsupported';

export type UrlResult =
  | { ok: true; value: string }
  | { ok: false; code: UrlErrorCode };

const schemePattern = /^[a-zA-Z][a-zA-Z\d+.-]*:/;
const hostPortPattern = /^[^/\s]+:\d+(?:[/?#]|$)/;

export function normalizeWebUrl(rawValue: string): UrlResult {
  const value = rawValue.trim();

  if (!value) {
    return {
      ok: false,
      code: 'empty',
    };
  }

  // Treat common host:port entries as bare hosts, not as custom schemes.
  const hasExplicitScheme = schemePattern.test(value) && !hostPortPattern.test(value);

  if (!hasExplicitScheme && /\s/.test(value)) {
    return {
      ok: false,
      code: 'invalid',
    };
  }

  if (hasExplicitScheme && !/^https?:/i.test(value)) {
    return {
      ok: false,
      code: 'unsupported',
    };
  }

  const candidate = hasExplicitScheme ? value : `https://${value}`;

  try {
    const url = new URL(candidate);

    if (
      !url.hostname ||
      url.hostname.includes('%') ||
      /\s/.test(url.hostname) ||
      (url.protocol !== 'http:' && url.protocol !== 'https:')
    ) {
      throw new Error('Unsupported URL');
    }

    return { ok: true, value: url.toString() };
  } catch {
    return {
      ok: false,
      code: 'invalid',
    };
  }
}

export function qrFileName(urlValue: string): string {
  try {
    const hostname = new URL(urlValue).hostname
      .replace(/^www\./, '')
      .replace(/[^a-z0-9-]+/gi, '-');

    return `easyqr-${hostname || 'link'}.png`;
  } catch {
    return 'easyqr-link.png';
  }
}
